// src/hooks/usePremiumTrial.js
import { useEffect, useState, useCallback } from "react";
import axios from "axios";

/**
 * usePremiumTrial
 * - Fetches current user's trial status
 * - Starts a 15-day trial (once) when called
 *
 * Returns: { trial, loading, error, refresh, startTrial }
 * trial shape (from server):
 *   {
 *     user_uuid: string,
 *     started_at: string,
 *     expires_at: string,
 *     days_left: number,
 *     is_trial_active: boolean,
 *     is_trial_expired: boolean
 *   }
 */
export default function usePremiumTrial() {
  const [trial, setTrial] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  const fetchStatus = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await axios.get("/api/premium/trial/status");
      setTrial(data?.trial || null);
    } catch (err) {
      // 401: not logged in; 500: server; handle generically for now
      setError(err?.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

// inside usePremiumTrial
const startTrial = async (payload = {}) => {
  setLoading(true);
  try {
    const token = localStorage.getItem("token");
    const { data } = await axios.post("/api/premium/trial/start", payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (data?.trial) setTrial(data.trial);
    return data; // <--- important
  } catch (e) {
    setError(e);
    throw e;
  } finally {
    setLoading(false);
  }
};


  useEffect(() => { fetchStatus(); }, [fetchStatus]);

  return { trial, loading, error, refresh: fetchStatus, startTrial };
}
